export const UPDATE_USER_LOCATION = "UPDATE_USER_LOCATION";
export const UPDATE_USER_STATE_LOCATION = "UPDATE_USER_STATE_LOCATION";
export const UPDATE_CURRENT_EXCHANGE_RATE = "UPDATE_CURRENT_EXCHANGE_RATE";
